var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.071 32.4931C14.7251 31.621 16.0331 31.403 17.0142 32.057C17.8862 32.7111 18.1042 34.0192 17.4502 35.0002L12.3269 41.9766C11.6729 42.8487 10.3648 43.0667 9.38376 42.4126C8.51171 41.7586 8.29369 40.4505 8.94773 39.4695L14.071 32.4931Z",
    fill: "#FF6407"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.9098 19.8481C11.9999 19.9571 12.8719 20.9381 12.7629 22.1372C12.6539 23.2273 11.6729 24.0993 10.4738 23.9903L1.86229 23.1183C0.772233 23.0092 -0.0998176 22.0282 0.00918859 20.8291C0.118195 19.7391 1.09925 18.867 2.29832 18.976L10.9098 19.8481Z",
    fill: "#FF6407"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.3979 14.0713C15.27 14.7254 15.488 16.0334 14.834 17.0145C14.1799 17.8865 12.8718 18.1046 11.8908 17.4505L4.91439 12.3272C4.04234 11.6732 3.82433 10.3651 4.47837 9.49307C5.13241 8.62102 6.44048 8.40301 7.31253 9.05704L14.3979 14.0713Z",
    fill: "#FF6407"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20.3934 10.8005C20.8294 11.8906 20.3934 13.0897 19.3034 13.5257C18.2133 13.9617 17.0142 13.5257 16.5782 12.4356L13.09 4.47818C12.654 3.38812 13.09 2.18905 14.1801 1.75302C15.2701 1.317 16.4692 1.75302 16.9052 2.84309L20.3934 10.8005Z",
    fill: "#FF6407"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.1519 10.9098C27.0428 11.9999 26.0618 12.8719 24.8627 12.7629C23.7727 12.6539 22.9006 11.6729 23.0096 10.4738L23.8817 1.86232C23.9907 0.772263 24.9717 -0.0997871 26.1708 0.00921912C27.2609 0.118225 28.1329 1.09928 28.0239 2.29835L27.1519 10.9098Z",
    fill: "#FF6407"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.929 14.3979C32.2749 15.2699 30.9669 15.4879 29.9858 14.8339C29.1138 14.1799 28.8957 12.8718 29.5498 11.9997L34.6731 5.02334C35.3271 4.15129 36.6352 3.93328 37.6162 4.58732C38.4883 5.24135 38.7063 6.54943 38.0523 7.53048L32.929 14.3979Z",
    fill: "#FF6407"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M36.1992 20.285C35.1092 20.721 33.9101 20.285 33.4741 19.1949C33.0381 18.1048 33.4741 16.9058 34.5642 16.4697L42.5216 12.9815C43.6117 12.5455 44.8107 12.9815 45.2468 14.0716C45.6828 15.1617 45.2468 16.3607 44.1567 16.7968L36.1992 20.285Z",
    fill: "#FF6407"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M36.0901 27.1515C35.0001 27.0424 34.128 26.0614 34.237 24.8623C34.346 23.7723 35.3271 22.9002 36.5262 23.0092L45.1377 23.8813C46.2277 23.9903 47.0998 24.9713 46.9908 26.1704C46.8817 27.2605 45.9007 28.1325 44.7016 28.0235L36.0901 27.1515Z",
    fill: "#FF6407"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M32.6021 32.9294C31.7301 32.2754 31.5121 30.9673 32.1661 29.9862C32.8202 29.1142 34.1282 28.8962 35.1093 29.5502L42.0857 34.6735C42.9577 35.3275 43.1757 36.6356 42.5217 37.5077C41.8677 38.3797 40.5596 38.5977 39.5785 37.9437L32.6021 32.9294Z",
    fill: "#FF6407"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M26.6067 36.1989C26.1706 35.1088 26.6067 33.9098 27.6967 33.4737C28.7868 33.0377 29.9859 33.4737 30.4219 34.5638L33.9101 42.5212C34.3461 43.6113 33.9101 44.8104 32.82 45.2464C31.7299 45.6824 30.5309 45.2464 30.0949 44.1563L26.6067 36.1989Z",
    fill: "#FF6407"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M19.8482 36.0899C19.9572 34.9998 20.9383 34.1278 22.1373 34.2368C23.2274 34.3458 24.0994 35.3268 23.9904 36.5259L23.1184 45.1374C23.0094 46.2274 22.0283 47.0995 20.8292 46.9905C19.7392 46.8815 18.8671 45.9004 18.9761 44.7014L19.8482 36.0899Z",
    fill: "#FF6407"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpin);
export default __webpack_public_path__ + "static/media/IconSpin.643d83d10acac0212b3b5743ecdb3fa5.svg";
export { ForwardRef as ReactComponent };